import type { IntakeColumnMappingProposal } from './intake.api';

/**
 * h5-5 FR31: mirrors `isIntakeColumnReviewed` from `packages/database`'s intake-sessions schema
 * (apps/api/src/modules/intake/review/review.service.ts enforces the same rule server-side, which
 * is the actual submit gate — this copy is presentation-only, for the counter/UI state). Kept as a
 * small local duplicate since the frontend never imports `@xxtract/database`.
 */
export function isIntakeColumnReviewed(column: IntakeColumnMappingProposal): boolean {
  return column.confirmed || column.ignored || column.confidenceClass === 'high';
}

/**
 * h13-5: de naam van een doelmarkt zoals de klant hem kent.
 *
 * Kennen we het land niet, dan blijft de code staan. Dat is lelijker dan een naam maar het is waar;
 * een verzonnen land of een lege plek maakt de vraag "voor welk land kies ik nu?" onbeantwoordbaar.
 */
export function marketName(t: (key: string, options?: Record<string, unknown>) => string, code: string): string {
  return t(`intake.review.markets.${code}`, { defaultValue: code });
}

/**
 * h13-5: de doelmarkten waarvoor nog geen enkele afnemer is gekozen.
 *
 * Dezelfde regel als de indienpoort aan de serverkant (`review.service.ts`). Deze kopie stuurt
 * alleen de knop; de poort zelf zit daar, want een uitgeschakelde knop is geen afscherming.
 */
export function marketsWithoutRetailer(markets: string[], choice: { targetMarket: string; retailers: unknown[] }[]): string[] {
  return markets.filter((market) => (choice.find((entry) => entry.targetMarket === market)?.retailers.length ?? 0) === 0);
}
